module.exports = __webpack_public_path__ + "img/bonus-logo.ceb94fd7.png";